import { authPost, PATH, authGetAll, authPut, authDelete } from '../../http';
import { GetFilter, Id, Post, Put, Slug, Tag } from '../types';

export const postTag = async (item: Post<Tag>) => {
  return await authPost(`api/v1/${PATH.MISURE}/${PATH.TAGS}/`, item);
};

export const getTagById = async ({ id }: Id) => {
  return await authGetAll(
    `api/v1/${PATH.MISURE}/${PATH.PUBLIC}/${PATH.TAGS}/${id}`,
  );
};

export const getTagBySlug = async ({ slug }: Slug) => {
  return await authGetAll(
    `api/v1/${PATH.MISURE}/${PATH.PUBLIC}/${PATH.TAGS}/${PATH.SLUG}/${slug}`,
  );
};

export const getAllTags = async ({
  skip,
  limit,
  visible_only = false,
}: GetFilter & { visible_only?: boolean }) => {
  return await authGetAll(
    `api/v1/${PATH.MISURE}/${PATH.PUBLIC}/${PATH.TAGS}/`,
    { skip, limit, visible_only },
  );
};

export const putTag = async (item: Put<Tag>) => {
  return await authPut(`api/v1/${PATH.MISURE}/${PATH.TAGS}`, item);
};

export const deleteTag = async ({ id }: Id) => {
  return await authDelete(`api/v1/${PATH.MISURE}/${PATH.TAGS}/${id}`);
};
